export default {
  alpha: {
    Á: 'A',
    À: 'A',
    Â: 'A',
    Ä: 'AE',
    Ã: 'A',
    Ă: 'A',
    Å: 'AA',
    Ā: 'A',
    Ą: 'A',
    Ǎ: 'A',
    Ǻ: 'A',
    Ǽ: 'A',
    Ć: 'C',
    Ĉ: 'C',
    Č: 'C',
    Ċ: 'C',
    Ç: 'C',
    Ð: 'D',
    Ď: 'D',
    É: 'E',
    È: 'E',
    Ê: 'E',
    Ë: 'E',
    Ĕ: 'E',
    Ė: 'E',
    Ē: 'E',
    Ę: 'E',
    Ě: 'E',
    Ĝ: 'G',
    Ğ: 'G',
    Ġ: 'G',
    Ģ: 'G',
    Ħ: 'Н',
    Ĥ: 'H',
    Í: 'I',
    Ì: 'I',
    Î: 'I',
    Ï: 'I',
    Ĩ: 'I',
    İ: 'I',
    Ī: 'I',
    Į: 'I',
    Ĭ: 'I',
    Ǐ: 'I',
    Ĵ: 'J',
    Ķ: 'K',
    Ł: 'L',
    Ĺ: 'L',
    Ľ: 'L',
    Ļ: 'L',
    Ŀ: 'L',
    Ń: 'N',
    Ñ: 'N',
    Ň: 'N',
    Ņ: 'N',
    Ƞ: 'N',
    Ø: 'OE',
    Ó: 'O',
    Ò: 'O',
    Ô: 'O',
    Ö: 'OE',
    Õ: 'O',
    Ő: 'O',
    Ō: 'O',
    Ŏ: 'O',
    Ơ: 'O',
    Ǒ: 'O',
    Ǿ: 'OE',
    Ŕ: 'R',
    Ř: 'R',
    Ŗ: 'R',
    Ś: 'S',
    Ŝ: 'S',
    Š: 'S',
    Ş: 'S',
    Ŧ: 'T',
    Ť: 'T',
    Ţ: 'T',
    Ú: 'U',
    Ù: 'U',
    Û: 'U',
    Ü: 'UE',
    Ũ: 'U',
    Ŭ: 'U',
    Ű: 'U',
    Ů: 'U',
    Ū: 'U',
    Ų: 'U',
    Ư: 'U',
    Ǔ: 'U',
    Ǖ: 'U',
    Ǘ: 'U',
    Ǚ: 'U',
    Ǜ: 'U',
    Ŵ: 'W',
    Ý: 'Y',
    Ŷ: 'Y',
    Ÿ: 'Y',
    Ź: 'Z',
    Ž: 'Z',
    Ż: 'Z',
    Þ: 'TH',
    Æ: 'AE',
    Ĳ: 'IJ',
    Œ: 'OE',
    ß: 'SS',

    // Cyrillic
    А: 'A',
    Б: 'B',
    В: 'V',
    Г: 'G',
    Д: 'D',
    Е: 'E',
    Ё: 'E',
    Ж: 'ZH',
    З: 'Z',
    И: 'I',
    Й: 'I',
    К: 'K',
    Л: 'L',
    М: 'M',
    Н: 'N',
    О: 'O',
    П: 'P',
    Р: 'R',
    С: 'S',
    Т: 'T',
    У: 'U',
    Ф: 'F',
    Х: 'KH',
    Ц: 'TS',
    Ч: 'CH',
    Ш: 'SH',
    Щ: 'SHCH',
    Ь: '',
    Ы: 'Y',
    Ъ: 'IE',
    Э: 'E',
    Ю: 'IU',
    Я: 'IA',

    І: 'I',
    Ґ: 'G',
    Ў: 'U',
    Ѫ: 'U',
    ƒ: 'G',
    Ћ: 'D',
    Ѕ: 'DZ',
    Ј: 'J',
    Ќ: 'K',
    Љ: 'LJ',
    Њ: 'NJ',
    Һ: 'C',
    Џ: 'DZ',
    Є: 'IE',
    Ї: 'I',
  },
  enToRu: {
    q: 'й',
    w: 'ц',
    e: 'у',
    r: 'к',
    t: 'е',
    y: 'н',
    u: 'г',
    i: 'ш',
    o: 'щ',
    p: 'з',
    '[': 'х',
    '{': 'х',
    ']': 'ъ',
    '}': 'ъ',
    a: 'ф',
    s: 'ы',
    d: 'в',
    f: 'а',
    g: 'п',
    h: 'р',
    j: 'о',
    k: 'л',
    l: 'д',
    ';': 'ж',
    ':': 'ж',
    "'": 'э',
    '"': 'э',
    '`': 'ё',
    '~': 'ё',
    z: 'я',
    x: 'ч',
    c: 'с',
    v: 'м',
    b: 'и',
    n: 'т',
    m: 'ь',
    ',': 'б',
    '<': 'б',
    '.': 'ю',
    '>': 'ю',
  },
  ruToEn: {
    й: 'q',
    ц: 'w',
    у: 'e',
    к: 'r',
    е: 't',
    н: 'y',
    г: 'u',
    ш: 'i',
    щ: 'o',
    з: 'p',
    х: '[',
    ъ: ']',
    ф: 'a',
    ы: 's',
    в: 'd',
    а: 'f',
    п: 'g',
    р: 'h',
    о: 'j',
    л: 'k',
    д: 'l',
    ж: ';',
    э: '“',
    ё: '~',
    я: 'z',
    ч: 'x',
    с: 'c',
    м: 'v',
    и: 'b',
    т: 'n',
    ь: 'm',
    б: ',',
    ю: '.',
  },
  space: {
    ' ': ' ', // charCode   32 — space
    ' ': ' ', // charCode  160 — &nbsp;
    ' ': ' ', // charCode 8201 — &thinsp;
  },
  hyphen: {
    '-': '-',
    '–': '-',
    '—': '-',
  },
  numeric: {
    0: '0',
    1: '1',
    2: '2',
    3: '3',
    4: '4',
    5: '5',
    6: '6',
    7: '7',
    8: '8',
    9: '9',
  },
};
